import { useMemo } from 'react'

import { AgChartOptions } from 'ag-charts-community'

import { CustomAgChart } from '@fortem-monorepo/react-ag'

import { ICReportChartPrimitive } from '@/pages/funds/ic-report/components/primitives/types'
import { diversifiers } from '@/react-query/queries/ic-report/hooks'

export interface RatesVegaChartProps extends ICReportChartPrimitive {}

export const RatesVegaChart: React.FC<RatesVegaChartProps> = ({ params, options }) => {
  const query = diversifiers.useRatesVolatilities(params)
  const data = query.data ?? []

  const formattedData = useMemo(() => {
    return data.map((item: any) => ({ ...item, date: new Date(item.date) }))
  }, [data])

  const mergedOptions: AgChartOptions = {
    title: {
      text: 'Net Vega',
      fontSize: 14,
    },
    data: formattedData,
    series: [
      {
        type: 'line',
        xKey: 'date',
        yKey: 'SGIVR2UV Vega',
        stroke: '#38b044',
        marker: {
          size: 0,
        },
      },
    ],
    axes: [
      {
        type: 'time',
        position: 'bottom',
        label: { format: '%d %b %y' },
        nice: false,
      },
      { type: 'number', position: 'left' },
    ],
    ...options,
  }

  return <CustomAgChart options={mergedOptions} />
}
